import React from "react";
import { Box, Typography, Container } from "@mui/material";
import PropTypes from "prop-types";
import Header from "../Dashboard/Header/Header";
import Footer from "../Dashboard/Footer/Footer";
import { Outlet } from "react-router-dom";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const MainComponent = () => {
  return (
    <>
      <Box
        style={{
          width: "100%",
          justifyContent: "center",
          position: "fixed",
          backgroundColor: "#ececec",
          alignItems: "center",
          height: "100vh",
          overflow: "auto",
          display:"flex"
        }}
      >
        <Header />
        <Container
          sx={{
            backgroundColor: "white",
            backgroundImage: "url(/assets/images/backgroundWater.jpg)",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            borderRadius: "20px",
            width: { xs: "100%", sm: "97%", md: "87%", lg: "60%", xl: "57%" },
            padding: "30px",
            height: { xs: "90%", sm: "60%" },
            // marginTop: { xs: "40px", sm: "150px" },
            boxShadow: "0 0 10px rgba(0, 0, 0, 0.7)",
          }}
        >
          <Outlet />
        </Container>
      </Box>
      <Footer />
    </>
  );
};

export default MainComponent;
